import { render, staticRenderFns } from "./LoaderContainer.vue?vue&type=template&id=347da930&"
import script from "./LoaderContainer.vue?vue&type=script&lang=js&"
export * from "./LoaderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports